import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from '@/components/home/HeroSection';
import FeaturesStrip from '@/components/home/FeaturesStrip';
import CategoriesSection from '@/components/home/CategoriesSection';
import TopProducts from '@/components/home/TopProducts';
import GallerySection from '@/components/home/GallerySection';
import SpecialProducts from '@/components/home/SpecialProducts';
import BlogSection from '@/components/home/BlogSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';

export const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesStrip />
        <CategoriesSection />
        <TopProducts />
        <GallerySection />
        <SpecialProducts />
        <TestimonialsSection />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;